import { Button, CircularProgress, FormHelperText } from "@mui/material";
import { SentStatus } from "../types";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Download } from "@mui/icons-material";

export const SubmitPage = (props: {
    status: SentStatus
    onSubmit: () => void
    onReset: () => void
    onClose?: () => void
    inModal?: boolean
}) => {
    return (
        <div>
            {props.status === 'sending' &&
                <Grid container justifyContent={'center'} alignItems={'center'}>
                    <CircularProgress size={'1.5rem'} sx={{ margin: '1rem' }} />Generating report...
                </Grid>
            }
            {(props.status === 'unsent' || props.status === 'sent' || props.status === 'error') &&
                <>
                    {props.status === 'sent' &&
                        <p>Your report has been created! Download will automatically start, otherwise click the Download button below.</p>
                    }
                    {props.status === 'error' &&
                        <FormHelperText error>There was an error, please try again.</FormHelperText>
                    }
                    <Grid container justifyContent={'space-between'} spacing={2}>
                        <Grid>
                            {props.inModal &&
                                <Button variant="outlined" onClick={props.onClose}>Close</Button>
                            }
                        </Grid>
                        <Grid>
                            <Button variant="outlined" onClick={props.onReset}>Start Over</Button>
                            <Button variant="contained" onClick={props.onSubmit} sx={{ marginLeft: '1rem' }}>Download <Download sx={{ marginLeft: '0.25rem' }} /></Button>
                        </Grid>
                    </Grid>
                </>
            }
        </div>
    )
}
